import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RestService } from '../../../services/rest/rest.service';
import { LtiAccount } from '../../../domain/lti/lti.domain';
import { LtiAccountStatus } from '../../../domain/lti/lti.enum';

@Injectable({
  providedIn: 'root'
})
export class WelcomeRestService {
  private readonly restService = inject(RestService);

  hasLtiEligibleAccounts(): Observable<boolean> {
    const params = {
      pathVariables: {
        subtype: 'LTI'
      }, params: {
        status: LtiAccountStatus.LTI_ELIGIBLE
      }
    };
    return this.restService.getResource('wealthInvestment.getInvestmentAccounts').get<Array<LtiAccount>>(params)
      .pipe(map((accounts: Array<LtiAccount>): boolean => accounts.length > 0));
  }
}

